export const GIT_BUNDLE_CONTENT_TYPE = "application/x-git-bundle";
